import i18n from '@/lib/i18n';
import HomeworkActivity from '@/models/HomeworkActivity';
import ScheduledLesson from '@/models/ScheduledLesson';
import Klass from '@/models/Klass';
import User from '@/models/User';
import moment from 'moment';
import { handleUserFullName } from '@/functions/handleUserFullName';
import { htmlToPlainText } from '@/utils/shared/htmlToPlainText';

type BuildMessageParams = {
  scheduledLesson: ScheduledLesson;
  klass: Klass;
  teacher: User | undefined;
  homeworkActivities: HomeworkActivity[];
};

type Line = { key: string; value: string | undefined };

const DASHED_LINE = '-----------------';

export default function formatScheduledLessonCopyMessage({
  scheduledLesson,
  klass,
  teacher,
  homeworkActivities,
}: BuildMessageParams) {
  const t = (key: string) =>
    i18n.t(`scheduledLessonReportModal.copyMessage.${key}`);
  const datetime = moment(scheduledLesson.datetime);

  const lines: Line[] = [
    { key: t('klass'), value: klass.name },
    { key: t('time'), value: datetime.format('HH:mm') },
    { key: t('date'), value: datetime.format('DD/MM/YYYY') },
    { key: t('lessonUrl'), value: klass.classRoomUrl },
    { key: t('teacher'), value: handleUserFullName(teacher) },
    { key: t('objectives'), value: scheduledLesson.lesson?.description },
    {
      key: t('homework'),
      value: htmlToPlainText(homeworkActivities.at(0)?.content),
    },
  ];

  const filledLines = lines
    .filter(({ value }) => !!value?.trim())
    .map(({ key, value }) => `${key} ${value?.trim()}`)
    .join('\n');

  const mensage = [DASHED_LINE, filledLines, t('footer'), DASHED_LINE].join(
    '\n',
  );

  return mensage;
}
